import { h } from 'preact';

export const CheckIcon = () => (
  <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2369 0L6.53218 7.56977L2.76314 3.86664L0 6.58177L6.53062 13L17 2.71412L14.2369 0Z" fill="white" />
  </svg>
);
